// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"c3bfbb6d","544":"c334859a","568":"c2828623"}[chunkId] + ".chunk.css";
};